<template>
  <div id="shopping-product">
      <shoppingBanner />  
    <div class="wrap">
      <div class="wrap_zh">
        <div class="shopping-title">
          <div class="shopping-title_name-center fl">全部商品-物料</div>
        </div>
      </div>
    </div>
    <div class="wrap">
      <div class="wrap_zh">
        <div class="product fl">
          <div class="product-goods fl" v-for="(vals,index) in listArr" :key="index"
            :class="recommendNum == index && 'on'" @mouseover="operaComFinger(index)"
            @mouseleave="operaFingerLeave">
            <router-link :to="'/shoppingMall/shoppingDetail/'+vals.id">
             <div class="product-goods_img fl">
              <img :src="vals.productImgUrl" alt>
            </div>
            <div class="product-goods_title fl">{{vals.productName}}</div>
            <div class="product-goods_info fl"><font v-for="(s,i) in vals.productLabelList" :key='s.id' v-if='i < 3'>{{s.labelName}}</font></div>
            <div class="product-goods_price fl">¥ {{vals.price}}</div>
            </router-link>
            <div class="product-goods_car-btn fr" @click="operaAddShoppingCar(vals)">
                <img src="../../assets/images/shopping/home_icon_shoppingcart2.png" alt>
              </div>
          </div>
          
        </div>
      </div>
    </div>
    
    <div class="wrap" v-if='moreHide'>
      <div class="wrap_zh">
          <div class="shopping-more fl" @click="operaNextPage">
              <img src="../../assets/images/shopping/product_icon_view.png" alt>
          </div>
            <div class="shopping-more fl" @click="operaNextPage">
                <p>查看更多</p>
            </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import shoppingBanner from "@/components/shoppingMall/shoppingBanner";
import { addProductCar,listProductAll } from "@/api";
import shoppingPublic from "@/assets/js/shoppingPublic";
export default {
  name: "shopping-product",
  components: {
    shoppingBanner
  },
  data() {
    return {
      prams: {
        currentPage: 1,
        pageSize: 8,
        category: "WL"
      },
      totalCount: 0,
      listArr:[],
      moreHide: true,
      recommendNum:'leave'
    };
  },
   created() {
    this.operaGetIndexList();
  },
  methods: {
    operaGetIndexList() {
      listProductAll(this.prams).then(res => {
        this.listArr = this.listArr.concat(res.obj.list);
        this.totalCount =  Math.ceil(res.obj.count/this.prams.pageSize);
        if(this.totalCount > this.prams.currentPage){
          this.moreHide = true;
        }else{
          this.moreHide = false;
        }
        this.$store.commit('SEARCH_SHOPPING_GOODS','WL');
      });
    },
    operaNextPage(){
      this.prams.currentPage ++;
      if(this.prams.currentPage > this.totalCount){
        this.moreHide = false;
      }else{
        this.operaGetIndexList();
      }
    },
    //添加購物車
    operaAddShoppingCar(obj) {
      let requestObj = {};
      requestObj.productId = obj.id;
      requestObj.price = obj.price;
      requestObj.quantity = 1;
      requestObj.subtotal = shoppingPublic.computePrice(obj.price * 1, 2);
      requestObj.productSpec = obj.productSpec;
      requestObj.systemType = this.$store.state.userInfo.brandId;
      requestObj.userId = this.$store.state.userInfo.staffId;
      addProductCar(requestObj).then(res => {
        if (res.code == 20001) {
          this.$emit("shoppingCars", "shoppingIndex");
        }
        this.$message({
          type: res.code == 20001 ? "success" : "error",
          message: res.msg
        });
      });
    },
    operaFinger(index) {
      this.fingerNum = index;
    },
    operaComFinger(index) {
      this.recommendNum = index;
    },
    operaFingerLeave() {
      this.fingerNum = "leave";
      this.recommendNum = "leave";
    }
  }
};
</script>
<style type="text/css">
/*首页推荐title*/
.shopping-title {
  line-height: 20px;
  padding-top: 42px;
}
.shopping-title_name {
  font-size: 20px;
  font-weight: bold;
  color: #333333;
}
.shopping-title_info {
  padding-left: 16px;
  font-size: 12px;
  color: #999999;
}
.shopping-title_name-center {
  width: 100%;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  color: #333333;
}
/*推荐商品*/
.product {
  width: 1217px;
}
.product-goods {
    position: relative;
  margin-top: 27px;
  margin-bottom: 10px;
  margin-left: 8px;
  margin-right: 8px;
  width: 285px;
  height: 340px;
  background: #ffffff;
}
.product-goods.on {
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.12);
}
.product-goods_img{
    padding-top: 70px;
  width: 100%;
  text-align: center;
}
.product-goods_img img {
  width: 166px;
  height: 106px;
}

.product-goods_title{
    padding-top: 50px;
    width: 100%;
    text-align: center;
    font-size: 16px;
    color: #444444;
}
.product-goods_info{
    padding-top: 10px;
    width: 100%;
    text-align: center;
    font-size: 12px;
    color: #999999;
}
.product-goods_info font{
  margin-right: 5px;
}
.product-goods_price{
    padding-top: 12px;
    width: 100%;
    text-align: center;
    font-size: 14px;
    color: #F83B56;
}
.product-goods_car-btn {
    position: absolute;
    bottom: 20px;
    right: 16px;
  width: 36px;
  height: 36px;
  line-height: 36px;
  background: #f83c57;
  border-radius: 50%;
  text-align: center;
  cursor: pointer;
}
/*banner*/
.banner {
  width: 100%;
  height: 460px;
  overflow: hidden;
}

.banner ul {
  float: left;
  width: 3600px;
}
.banner ul li {
  float: left;
  width: 1200px;
  height: 460px;
}
.banner ul li img {
  width: 1200px;
  height: 460px;
}
.banner-bottom {
  margin-top: -30px;
  width: 100%;
  text-align: center;
}
.banner-bottom li {
  display: inline-block;
  margin-right: 3px;
  margin-left: 3px;
  width: 12px;
  height: 12px;
  background: #ffffff;
  border: 2px solid #c6c6c6;
  border-radius: 50%;
  cursor: pointer;
}
.banner-bottom li.on {
  background: #333333;
  opacity: 0.5;
  border-radius: 50%;
  border: none;
}
.shopping-banners{
  position: relative;
}
.wrap-shop_left-btn{
  position: absolute;
  left: 0px;
  top: 190px;
  width: 40px;
  height: 80px;
  background: url('../../assets/images/shopping/home_icon_leftarrow.png') no-repeat center #999794;
  cursor: pointer;
}
.wrap-shop_right-btn{
  position: absolute;
  left: 0px;
  top: 190px;
  width: 40px;
  height: 80px;
  background: url('../../assets/images/shopping/home_icon_leftarrow.png') no-repeat center #999794;
  cursor: pointer;
}

/*更多*/
.shopping-more{
    width: 100%;
    text-align: center;
}
.shopping-more img{
    padding-top: 35px;
    cursor: pointer;
}
.shopping-more p{
    padding-top: 10px;
    font-size: 12px;
    color: #B1B1B1;
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/shoppingMall/shoppingMateriel.vue